import React from 'react';
import PropTypes from 'prop-types';
import { InputLabel, Select, MenuItem } from '@mui/material';
import ArgonSelectRoot from './ArgonSelectRoot';
import ArgonTypography from 'components/ArgonTypography';

function ArgonSelect({ name, label, value, onChange, options, placeholder, ...rest }) {
  return (
    <ArgonSelectRoot variant="outlined" {...rest}>
      {label && <InputLabel id="argon-select-label">{label}</InputLabel>}
      <Select
        name={name}
        displayEmpty={true}
        labelId="argon-select-label"
        value={value}
        onChange={onChange}
        label={label}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <ArgonTypography variant="caption" color="text" fontWeight="regular">
                {placeholder}
              </ArgonTypography>
            );
          }
          return options.find((option) => option.value === selected)?.label;
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </ArgonSelectRoot>
  );
}

ArgonSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
};

export default ArgonSelect;
